import { LineLoginRequest, LineLoginResponse, LineMessage } from "@/types";
import { serviceApiInstance } from "@/utils/helper";
import { AxiosResponse } from "axios";

export type RequestOtpResponse = {
  status: string;
  message: string;
  token: string;
  refno: string;
};

export const verifyLineLogin = async (
  params: LineLoginRequest
): Promise<AxiosResponse<LineLoginResponse>> => {
  return await serviceApiInstance.post<LineLoginResponse>(`auth/login`, params);
};

export const requestOtp = async (
  phoneNumber: string
): Promise<AxiosResponse<RequestOtpResponse>> => {
  return await serviceApiInstance.post<RequestOtpResponse>(`auth/request/otp`, {
    phoneNumber,
  });
};

export const sendLineMessage = async (
  to: string,
  messages: LineMessage[]
): Promise<void> => {
  await serviceApiInstance
    .post<any>(`line-messaging/push`, { to, messages })
    .then((res) => res.data);
};

// Branch that owns the LIFF app the member entered through (per-branch LINE
// OAs). null = tenant-level or unknown LIFF.
export type LiffBranchResponse = { branchId: number | null };

export const getLiffBranch = async (
  liffId: string
): Promise<LiffBranchResponse> => {
  const response = await serviceApiInstance.get<LiffBranchResponse>(
    `line-messaging/liff-branch`,
    { params: { liffId } }
  );
  return response.data;
};
